import { createAction } from 'redux-actions';
import * as types from '../constants/actionTypes/selectedElements';

export const addSelectedElement = createAction(types.ADD_SELECTED_ELEMENT);
export const removeSelectedElement = createAction(types.REMOVE_SELECTED_ELEMENT);
export const removeAllSelectedElements = createAction(types.REMOVE_ALL_SELECTED_ELEMENTS);
